import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Pay from '@/components/Pay'
import Main from '@/components/Main'
import Charge from '@/components/rent/Charge'
import CarMap from '@/components/rent/CarMap'
import Bills from '@/components/rent/Bills'
import History from '@/components/rent/History'
import Student from '@/components/rent/Student'
import StudentHJD from '@/components/rent/StudentHJD'
import SpaceBills from '@/components/rent/SpaceBills'
import FeePackage from '@/components/rent/FeePackage'
import RefundPrepaid from '@/components/rent/RefundPrepaid'
import RefundFree from '@/components/rent/RefundFree'
import RefundHours from '@/components/rent/RefundHours'
import Card from '@/components/card/Card'
import CardHistory from '@/components/card/History'
import Coupon from '@/components/card/Coupon'
import Car from '@/components/data/Car'
import Coach from '@/components/data/Coach'
import CoachFingerSy from '@/components/data/CoachFingerSy'
import Secu from '@/components/data/Secu'
import School from '@/components/data/School'
import Sales from '@/components/data/Sales'
import User from '@/components/sys/User'
import Role from '@/components/sys/Role'
import ReportSchool from '@/components/report/School'
import ReportReturn from '@/components/report/Return'
import ReportReturnMonth from '@/components/report/ReturnMonth'
import ReportCoach from '@/components/report/Coach'
import ReportOper from '@/components/report/Oper'
import ReportSecu from '@/components/report/Secu'
import ReportSales from '@/components/report/Sales'
import ReportStudent from '@/components/report/Student'
import ReportMonth from '@/components/report/Month'
import ReportRefund from '@/components/report/Refund'
import ReportCoachArea from '@/components/report/CoachArea'
import ReportCard from '@/components/report/Card'
import Ret from '@/components/return/Ret'
import RetPackage from '@/components/return/RetPackage'
import Return from '@/components/return/Return'
import Refund from '@/components/return/Refund'
import Discount from '@/components/return/Discount'
import ReturnHistory from '@/components/return/History'
import DiscountHistory from '@/components/return/DiscountHistory'
import Physical from '@/components/physical/Index'
import FinanceIndex from '@/components/finance/Index'
import FinanceItem from '@/components/finance/Item'
import FinanceAccount from '@/components/finance/Account'
import FinanceReport from '@/components/finance/Report'
import FinanceTransfer from '@/components/finance/Transfer'
import FinanceIncomeReport from '@/components/finance/IncomeReport'
import FinancePayable from '@/components/finance/Payable'
import SysTools from '@/components/admin/SysTools'
import SysDeviceList from '@/components/admin/DeviceList'
import Exam from '@/components/exam/Index'
import ExamCar from '@/components/exam/Car'
import ExamStudent from '@/components/exam/Student'
import ExamStudentHJD from '@/components/exam/StudentHJD'
import Expiry from '@/components/Expiry'
import AccessIndex from '@/components/access/Index'
import StudentRegister from '@/components/access/StudentRegister'
import AccessStaff from '@/components/access/Staff'
import CoachRegister from '@/components/access/CoachRegister'

Vue.use(Router)

export default new Router({
  mode: 'history', // 'hash'
  linkActiveClass: 'is-active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/login',
      component: Login
    },
    {
      path: '/pay',
      component: Pay
    },
    {
      path: '/expiry',
      component: Expiry
    },
    {
      path: '/',
      component: Main,
      children: [
        {
          path: '',
          redirect: 'charge'
        },
        {
          path: 'charge',
          component: Charge
        },
        {
          path: 'map',
          component: CarMap
        },
        {
          path: 'bills',
          component: Bills
        },
        {
          path: 'history',
          component: History
        },
        {
          path: 'student',
          component: Student
        },
        {
          path: 'student_hjd',
          component: StudentHJD
        },
        {
          path: 'spacebills',
          component: SpaceBills
        },
        {
          path: 'fee_package',
          component: FeePackage
        },
        {
          path: 'refund_prepaid',
          component: RefundPrepaid
        },
        {
          path: 'refund_free',
          component: RefundFree
        },
        {
          path: 'refund_hours',
          component: RefundHours
        },
        {
          path: 'card',
          component: Card
        },
        {
          path: 'card/history',
          component: CardHistory
        },
        {
          path: 'coupon',
          component: Coupon
        },
        {
          path: 'car',
          component: Car
        },
        {
          path: 'coach',
          component: Coach
        },
        {
          path: 'coach/new',
          component: Coach
        },
        {
          path: 'coach_finger_sy',
          component: CoachFingerSy
        },
        {
          path: 'secu',
          component: Secu
        },
        {
          path: 'school',
          component: School
        },
        {
          path: 'sales',
          component: Sales
        },
        {
          path: 'user',
          component: User
        },
        {
          path: 'finance',
          component: FinanceIndex
        },
        {
          path: 'finance/item',
          component: FinanceItem
        },
        {
          path: 'finance/account',
          component: FinanceAccount
        },
        {
          path: 'finance/income-report',
          component: FinanceIncomeReport
        },
        {
          path: 'finance/report',
          component: FinanceReport
        },
        {
          path: 'finance/transfer',
          component: FinanceTransfer
        },
        {
          path: 'finance/payable',
          component: FinancePayable
        },
        {
          path: 'report/school',
          component: ReportSchool
        },
        {
          path: 'report/coach',
          component: ReportCoach
        },
        {
          path: 'report/oper',
          component: ReportOper
        },
        {
          path: 'report/secu',
          component: ReportSecu
        },
        {
          path: 'report/sales',
          component: ReportSales
        },
        {
          path: 'report/card',
          component: ReportCard
        },
        {
          path: 'report/return',
          component: ReportReturn
        },
        {
          path: 'report/return_month',
          component: ReportReturnMonth
        },
        {
          path: 'report/student',
          component: ReportStudent
        },
        {
          path: 'report/month',
          component: ReportMonth
        },
        {
          path: 'report/refund',
          component: ReportRefund
        },
        {
          path: 'report/coach_area',
          component: ReportCoachArea
        },
        {
          path: 'ret',
          component: Ret
        },
        {
          path: 'ret-package',
          component: RetPackage
        },
        {
          path: 'return',
          component: Return
        },
        {
          path: 'return/history',
          component: ReturnHistory
        },
        {
          path: 'refund',
          component: Refund
        },
        {
          path: 'discount',
          component: Discount
        },
        {
          path: 'discount/history',
          component: DiscountHistory
        },
        {
          path: 'sys/role',
          component: Role
        },
        {
          path: 'sys/tools',
          component: SysTools
        },
        {
          path: 'sys/device_list',
          component: SysDeviceList
        },
        {
          path: 'physical',
          component: Physical
        },
        {
          path: 'kc_exam',
          component: Exam
        },
        {
          path: 'kc_exam_car',
          component: ExamCar
        },
        {
          path: 'kc_exam_student',
          component: ExamStudent
        },
        {
          path: 'kc_exam_student_hjd',
          component: ExamStudentHJD
        },
        {
          path: 'access',
          component: AccessIndex
        },
        {
          path: 'access/student-register',
          component: StudentRegister
        },
        {
          path: 'access/staff',
          component: AccessStaff
        },
        {
          path: 'access/coach-register',
          component: CoachRegister
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js